/**
 * Jediné místo s konfigurací mapových dlaždic. Fáze 1 = OSM raster. Přepnutí na vlastní
 * `maptiler/tileserver-gl` = jen změna `url` na jeho raster endpoint
 * (`…/styles/{style}/{z}/{x}/{y}.png`); Leaflet renderuje raster přímo. Pokud bude později potřeba
 * pravý vektor (GL styl), doplní se plugin `maplibre-gl-leaflet` — zbytek mapového kódu se nemění.
 *
 * URL lze přepsat přes runtime config (`window`-injected) bez rebuildu.
 */
export interface MapTileSource {
  url: string;
  attribution: string;
  maxZoom: number;
}

const OSM_TILE_SOURCE: MapTileSource = {
  url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  attribution: '© OpenStreetMap přispěvatelé',
  maxZoom: 19,
};

/** Vrátí aktivní zdroj dlaždic (default OSM; budoucí přepnutí na tileserver-gl tady). */
export function getMapTileSource(): MapTileSource {
  return OSM_TILE_SOURCE;
}

/** Výchozí střed mapy (ČR), když nejsou žádné souřadnice. */
export const DEFAULT_MAP_CENTER: [number, number] = [49.8, 15.5];
export const DEFAULT_MAP_ZOOM = 7;
